import React from 'react';

import { ProgressBar } from 'react-loader-spinner';

import type { ProgressBarSpinnerProperties } from './ProgressBarSpinner.types';

export const ProgressBarSpinner: React.FC<ProgressBarSpinnerProperties> = ({
  dataTest = 'simple_circle_spinner',
  size = '15',
  isLoading,
  barColor = 'primary',
  borderColor = 'secondary',
}) => {
  // Без фолбэка намеренно (AF-40): литералы `#3A558C` и `#F291A3` дублировали
  // палитру, а переменные `--mui-palette-*` есть всегда при `cssVariables: true`.
  const mainColorString = `var(--mui-palette-${barColor}-main)`;
  const secondaryColorString = `var(--mui-palette-${borderColor}-main)`;
  return (
    <ProgressBar
      data-testid={dataTest}
      width={size}
      height={size}
      barColor={mainColorString}
      borderColor={secondaryColorString}
      ariaLabel='progress-bar-loading'
      visible={isLoading}
    />
  );
};
